import { defineMessages } from 'react-intl'

const scope = `procurify.hooks.useFormatCardStatusLabel`

export default defineMessages({
  activeLabel: {
    id: `${scope}.activeLabel`,
    defaultMessage: 'Active',
  },
  pendingLabel: {
    id: `${scope}.pendingLabel`,
    defaultMessage: 'Pending',
  },
  lockedLabel: {
    id: `${scope}.lockedLabel`,
    defaultMessage: 'Locked',
  },
  blockedLabel: {
    id: `${scope}.blockedLabel`,
    defaultMessage: 'Blocked',
  },
  canceledLabel: {
    id: `${scope}.canceledLabel`,
    defaultMessage: 'Canceled',
  },
})
